import clsx from "clsx";
import { ClientSide } from "~/@types";
import { IExpert } from "~/@types/generated/contentful";
import {
  Arrow,
  Email,
  Facebook,
  Linkedin,
  Twitter,
  YouTube,
} from "../icons/svgs";

export type ExpertSocialLinksProps = {
  className?: string;
  expert: ClientSide<IExpert>;
  invertedColors?: boolean;
};

const getPlatformName = (platform: string): string => {
  const lowerPlatform = platform.toLowerCase();
  if (lowerPlatform === "twitter") return "x";
  if (lowerPlatform === "facebook") return "facebook";
  return lowerPlatform;
};

export default function ExpertSocialLinks({
  className = "",
  expert,
  invertedColors,
}: ExpertSocialLinksProps) {
  return (
    <div
      id="expert-social-links"
      className={`col-span-full flex gap-8 ${className}`}
    >
      {expert.fields.email && (
        <div className="flex items-center gap-4">
          <span className="cta shrink-0">contact</span>
          <a
            href={`mailto:${expert.fields.email}`}
            className={clsx("rounded", {
              "bg-black text-white": !invertedColors,
              "bg-white text-black": invertedColors,
            })}
            data-component-type="social-link"
            data-social-platform="email"
            data-click-id={`expert-email-${expert.fields.slug}`}
            id={`expert-link-email-${expert.fields.slug}`}
          >
            <Email />
          </a>
        </div>
      )}
      {expert.fields.socialMedia && (
        <div className="flex items-center gap-4">
          <span className="cta shrink-0">follow</span>
          <span className="flex flex-wrap gap-2">
            {expert.fields.socialMedia.map((link, index) => {
              const platform = getPlatformName(link.fields.platform);
              switch (link.fields.platform) {
                case "twitter":
                  return (
                    <a
                      key={link.sys.id}
                      href={link.fields.url}
                      target="_blank"
                      rel="noreferrer"
                      className={clsx("rounded", {
                        "bg-black text-white": !invertedColors,
                        "bg-white text-black": invertedColors,
                      })}
                      data-component-type="social-link"
                      data-social-platform={platform}
                      data-click-id={`expert-${platform}-${expert.fields.slug}`}
                      id={`expert-link-${platform}-${expert.fields.slug}`}
                    >
                      <Twitter />
                    </a>
                  );
                case "linkedin":
                  return (
                    <a
                      key={link.sys.id}
                      href={link.fields.url}
                      target="_blank"
                      rel="noreferrer"
                      className={clsx("rounded", {
                        "bg-black text-white": !invertedColors,
                        "bg-white text-black": invertedColors,
                      })}
                      data-component-type="social-link"
                      data-social-platform={platform}
                      data-click-id={`expert-${platform}-${expert.fields.slug}`}
                      id={`expert-link-${platform}-${expert.fields.slug}`}
                    >
                      <Linkedin />
                    </a>
                  );
                case "youtube":
                  return (
                    <a
                      key={link.sys.id}
                      href={link.fields.url}
                      target="_blank"
                      rel="noreferrer"
                      className={clsx("rounded", {
                        "bg-black text-white": !invertedColors,
                        "bg-white text-black": invertedColors,
                      })}
                      data-component-type="social-link"
                      data-social-platform={platform}
                      data-click-id={`expert-${platform}-${expert.fields.slug}`}
                      id={`expert-link-${platform}-${expert.fields.slug}`}
                    >
                      <YouTube />
                    </a>
                  );
                case "facebook":
                  return (
                    <a
                      key={link.sys.id}
                      href={link.fields.url}
                      target="_blank"
                      rel="noreferrer"
                      className={clsx("rounded", {
                        "bg-black text-white": !invertedColors,
                        "bg-white text-black": invertedColors,
                      })}
                      data-component-type="social-link"
                      data-social-platform={platform}
                      data-click-id={`expert-${platform}-${expert.fields.slug}`}
                      id={`expert-link-${platform}-${expert.fields.slug}`}
                    >
                      <Facebook />
                    </a>
                  );
              }
              return (
                <a
                  key={link.sys.id}
                  href={link.fields.url}
                  target="_blank"
                  rel="noreferrer"
                  className={clsx("rounded", {
                    "bg-black text-white": !invertedColors,
                    "bg-white text-black": invertedColors,
                  })}
                  data-component-type="social-link"
                  data-social-platform={platform}
                  data-click-id={`expert-${platform}-${expert.fields.slug}`}
                  id={`expert-link-${platform}-${expert.fields.slug}`}
                >
                  <Arrow />
                </a>
              );
            })}
          </span>
        </div>
      )}
    </div>
  );
}
